<div class="wrapper">
    <p *ngIf="class==='error'" class="tiny error-message">{{errorMessage}}</p>
    <div class="checkbox">
        <mat-checkbox [disabled]="disabled" [ngClass]="class" (change)="checkChanged($event)" [checked]="isChecked" [color]="color">
        </mat-checkbox>
        <div class="checkbox-label" [innerHTML]="content"></div>
    </div>
</div>